import { ca } from '@cian/analytics';
import { EServiceId } from '../../../../../../redux/reducers';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../../../types/analytics';
import { getFormId } from '../../../../../../../browser/services/formId';

interface ITrackPackagesLayoutShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  activeServiceId: EServiceId;
  bet: number | null;
  offerPosition: number | null;
  page: number | null;
}

export const trackPackagesLayoutShow = (params: ITrackPackagesLayoutShowParams) => {
  const { analyticsOfferStatus, analyticsProduct, offerPosition, page, bet, activeServiceId } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_show',
    label: 'short',
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        vas: activeServiceId,
        bid: bet,
        position: offerPosition,
        page_number: page,
        form_id: getFormId(),
      },
    },
  });
};
